import { formatIndexRatio } from "../../utilities/dashboardAggregations";

interface IndexBadgeProps {
    current: number;
    previous: number;
    label?: string;
    fontSize?: number;
    inline?: boolean;
}

export function IndexBadge({ current, previous, label = "Indeks", fontSize = 12, inline = false }: IndexBadgeProps) {
    const display = formatIndexRatio(current, previous);
    if (display === null) return null;
    const ratio = current / previous;
    const color = ratio >= 1 ? "#1b8a5a" : "#c53a31";
    const Tag = inline ? "span" : "div";
    return (
        <Tag style={{ fontSize, marginTop: inline ? 0 : 4 }}>
            {label} <strong style={{ color }}>{display}</strong>
        </Tag>
    );
}
